import * as user from './user';
import * as homeAPI from './homeAPI';

export default {
  user,
  homeAPI



}